
// Used when you do not want the default template, e.g error page (template)
export default {
  name: 'LayoutEmpty'
}
